import AgoraRTC, {
  CameraVideoTrackInitConfig,
  IAgoraRTCClient,
  MicrophoneAudioTrackInitConfig,
} from 'agora-rtc-sdk-ng';
import { environment } from '../../../enviroments';
import { getAccessToken } from '../auth/getAccessToken';

type InitVideoCallParams = {
  channelID: string;
  consultationID: string;
  userID: string;
  client: IAgoraRTCClient;
};

export const microphoneConfig: MicrophoneAudioTrackInitConfig = {
  AEC: true,
  AGC: true,
  ANS: true,
};
export const cameraConfig: CameraVideoTrackInitConfig = {
  facingMode: 'user',
  optimizationMode: 'motion',
  encoderConfig: '360p',
};

export const initVideoCall = async ({ channelID, consultationID, userID, client }: InitVideoCallParams) => {
  const token = await getAccessToken(userID, consultationID, channelID);

  const microphoneTrack = await AgoraRTC.createMicrophoneAudioTrack(microphoneConfig);

  const camerasList = await AgoraRTC.getCameras().catch(() => {});
  const cameraTrack = await AgoraRTC.createCameraVideoTrack(cameraConfig).catch(() => {});

  await client.join(environment.AGORA.appID, channelID, token, `${Date.now()}_cam`);

  if (cameraTrack) {
    await client.publish([microphoneTrack, cameraTrack]);
  } else {
    await client.publish([microphoneTrack]);
  }

  return {
    microphoneTrack,
    cameraTrack,
    camerasList,
  };
};
